import { createSelector } from 'reselect';

export const getTicketsAccesor = state => state.tickets.tickets;
export const getFetchingExport = state => state.tickets.tickets.exportFetching;

export const ticketsSelector = createSelector(getTicketsAccesor, tickets => tickets);
export const fetchingExportSelector = createSelector(getFetchingExport, exportFetching => exportFetching);
